import styled from "styled-components";
import { TabComponentProps, toNumber } from "../../types/types";
import { useEffect, useState } from "react";
import InputInfoTab from "../enterprise/inputInfoTab";
import InputChargeTab from "../enterprise/inputChargeTab";
import ChargeExportModalComponent from "../enterprise/chargeExportModalComponent";
import InputItemTab from "../enterprise/inputItemTab";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 5vw;
`;

const ContentsArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 2vw;
  padding-bottom: 2vw;
  border-bottom-left-radius: 1vw;
  border-bottom-right-radius: 1vw;
  box-shadow: 3px 3px 20px -10px #16161642;
  margin-bottom: 4vw;
`;

const HeaderItemBox = styled.div<{
  $menucounts: number;
  $selectedtab: number;
  $index: number;
}>`
  box-shadow: 3px 3px 10px -6px #16161642;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) =>
    props.$menucounts ? `${96 / props.$menucounts}%` : "40%"};
  height: 100%;
  background-color: ${(props) =>
    props.$index === props.$selectedtab ? "#ff7f3b" : "#d8d8d8"};
  font-weight: ${(props) =>
    props.$index === props.$selectedtab ? "500" : "500"};
  color: white;
  font-size: 2.2vw;
  font-weight: 600;
  border-top-left-radius: 1vw;
  border-top-right-radius: 1vw;
`;

export default function TabComponent(props: TabComponentProps) {
  const {
    tabMenuList,
    isDetailPage,
    data,
    setData,
    onChangeInput,
    currentPage,
    setCurrentPage,
    maxIndex,
    setMaxIndex,
  } = props;
  const [selectedTab, setSelectedTab] = useState(0);
  const [chargeExportModalVisible, setChargeExportModalVisible] =
    useState(false);

  // 3.견적서 내보내기 열기
  const chargeExportModalOpen = () => {
    setChargeExportModalVisible(true);
  };
  // 3.견적서 내보내기 닫기
  const chargeExportModalClose = () => {
    setChargeExportModalVisible(false);
  };

  // 4. 페이지별 토탈 가격 계산함수
  const computeTotal = (currentPage: number) => {
    setData((prev: any) => {
      const updatedData = { ...prev };
      let chargeListItem = updatedData.chargeList[currentPage - 1];

      // 5. 합계
      let totalValue =
        toNumber(chargeListItem.materialCost.total) +
        toNumber(chargeListItem.movingCost.total) +
        toNumber(chargeListItem.laborCost.total) +
        toNumber(chargeListItem.ectCost.total);
      // 6. 공과잡비 [5*N(5)%]
      let expenses = totalValue * (chargeListItem.expensesRate * 0.01);
      // 7. 일반관리비[(5+6)*N(10)%]
      let commonCost =
        (totalValue + expenses) * (chargeListItem.commonCostRate * 0.01);
      // 8. 이윤[(5+6+7)*N(10)%]
      let profit =
        (totalValue + expenses + commonCost) *
        (chargeListItem.profitRate * 0.01);
      // 8. 총용역원가
      let totalServiceCost = totalValue + expenses + profit + commonCost;
      // 9. 견적가
      let quotedPrice = Math.floor(totalServiceCost / 10000) * 10000;

      updatedData.chargeList[currentPage - 1].total =
        totalValue.toLocaleString();

      updatedData.chargeList[currentPage - 1].expenses =
        expenses.toLocaleString();

      updatedData.chargeList[currentPage - 1].commonCost =
        commonCost.toLocaleString();

      updatedData.chargeList[currentPage - 1].profit = profit.toLocaleString();

      updatedData.chargeList[currentPage - 1].totalServiceCost =
        totalServiceCost.toLocaleString();

      updatedData.chargeList[currentPage - 1].quotedPrice =
        quotedPrice.toLocaleString();

      return updatedData;
    });
  };

  return (
    <Wrapper>
      <HeaderArea>
        {tabMenuList.map((item) => {
          return (
            <HeaderItemBox
              key={item.id}
              $index={item.id}
              $menucounts={tabMenuList.length}
              $selectedtab={selectedTab}
              onClick={() => setSelectedTab(item.id)}
            >
              {item.title}
            </HeaderItemBox>
          );
        })}
      </HeaderArea>
      {selectedTab === 0 && (
        <ContentsArea>
          <InputInfoTab
            data={data}
            setData={setData}
            onChangeInput={onChangeInput}
          ></InputInfoTab>
        </ContentsArea>
      )}
      {selectedTab === 1 && (
        <InputItemTab
          data={data}
          setData={setData}
          openModal={chargeExportModalOpen}
          computeTotal={computeTotal}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          maxIndex={maxIndex}
          setMaxIndex={setMaxIndex}
        ></InputItemTab>
      )}
      {selectedTab === 2 && (
        <ContentsArea>
          <InputChargeTab
            data={data}
            setData={setData}
            openModal={chargeExportModalOpen}
            computeTotal={computeTotal}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            maxIndex={maxIndex}
            setMaxIndex={setMaxIndex}
          ></InputChargeTab>
        </ContentsArea>
      )}

      {chargeExportModalVisible && (
        <ChargeExportModalComponent
          isDetailPage={isDetailPage}
          data={data}
          setData={setData}
          onClose={chargeExportModalClose}
        ></ChargeExportModalComponent>
      )}
    </Wrapper>
  );
}
